<script>
import { Tag } from 'iview'
export default {
  functional: true,
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    },
    closable: {
      type: Boolean,
      default: true
    }
  },
  render (h, ctx) {
    return (
      <div
        style={`display: ${ctx.props.list.length ? 'block' : 'none'}`}
        class={`iv-tag-group iv-symbol-p8 ${ctx.data.staticClass}`}>
        {
          ctx.props.list.map((item, index) => {
            return <Tag closable={ctx.props.closable} {...{ on: { 'on-close': e => ctx.listeners.onClose(item, index) } } }>{item}</Tag>
          })
        }
      </div>
    )
  }
}
</script>
<style lang="scss">
  @import '~@/assets/css/base/variables/symbol.scss';
  .iv-tag-group{
    border: 1px #ccc dashed;
    border-radius: 4px;
  }
</style>
